import axios from 'axios';
import {backendHost} from '../../../../store/config';

const postUpdateGameFreespin = (params) => {
    return axios.post(`${backendHost}/api/admin/fs-game/detailUpdate`, params);
};

export {
    postUpdateGameFreespin
}